export default {
  name: 'Appraisal',
  description: 'Monitoring the Process Step / Inspections to Catch Errors',
  completed: false,
  color: '#00E396',
  banner: 'parallax-orange.jpg',
  costs: [
    {
      name: 'Test and Inspection',
      color: '',
      deleted: false,
      verified: false,
      visible: true,
      subCosts: [
        {
          name: 'Design Engineering',
          value: null
        },
        {
          name: 'Purchasing',
          value: null
        },
        {
          name: 'Production',
          value: null
        },
        {
          name: 'Accounting',
          value: null
        },
        {
          name: 'Finance',
          value: null
        },
        {
          name: 'Quality',
          value: null
        },
        {
          name: 'Materials',
          value: null
        },
        {
          name: 'Sales & Marketing',
          value: null
        },
        {
          name: 'Other',
          value: null
        }
      ],
    },
    {
      name: 'Instrument Calibration',
      color: '',
      deleted: false,
      verified: false,
      visible: true,
      subCosts: [
        {
          name: 'Design Engineering',
          value: null
        },
        {
          name: 'Purchasing',
          value: null
        },
        {
          name: 'Production',
          value: null
        },
        {
          name: 'Accounting',
          value: null
        },
        {
          name: 'Finance',
          value: null
        },
        {
          name: 'Quality',
          value: null
        },
        {
          name: 'Materials',
          value: null
        },
        {
          name: 'Sales & Marketing',
          value: null
        },
        {
          name: 'Other',
          value: null
        }
      ],
    },
    {
      name: 'Field Testing',
      color: '',
      deleted: false,
      verified: false,
      visible: true,
      subCosts: [
        {
          name: 'Design Engineering',
          value: null
        },
        {
          name: 'Purchasing',
          value: null
        },
        {
          name: 'Production',
          value: null
        },
        {
          name: 'Accounting',
          value: null
        },
        {
          name: 'Finance',
          value: null
        },
        {
          name: 'Quality',
          value: null
        },
        {
          name: 'Materials',
          value: null
        },
        {
          name: 'Sales & Marketing',
          value: null
        },
        {
          name: 'Other',
          value: null
        }
      ],
    },
    {
      name: 'Monitoring Process',
      color: '',
      deleted: false,
      verified: false,
      visible: true,
      subCosts: [
        {
          name: 'Design Engineering',
          value: null
        },
        {
          name: 'Purchasing',
          value: null
        },
        {
          name: 'Production',
          value: null
        },
        {
          name: 'Accounting',
          value: null
        },
        {
          name: 'Finance',
          value: null
        },
        {
          name: 'Quality',
          value: null
        },
        {
          name: 'Materials',
          value: null
        },
        {
          name: 'Sales & Marketing',
          value: null
        },
        {
          name: 'Other',
          value: null
        }
      ],
    },
  ]
};